import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  constructor(private swUpdate: SwUpdate) {}

  initialize(): void {
    if (!this.swUpdate.isEnabled) {
      console.log('Service Worker is not enabled');
      return;
    }

    // Check for updates on initialization
    this.checkForUpdates();
  }

  checkForUpdates(): void {
    this.swUpdate.checkForUpdate().then(() => {
      console.log('Checking for updates...');
    }).catch(err => {
      console.error('Error checking for updates:', err);
    });
  }

  activateUpdate(): Promise<void> {
    return this.swUpdate.activateUpdate().then(() => {
      window.location.reload();
    });
  }
}

